import { postGrowthEngineAnalytics } from './growthEngineApi'

export const STOCK_TAKE_ANALYTICS_EVENTS = Object.freeze({
  HISTORY_SEARCH_USED: 'stock_take_history_search_used',
  MULTI_SUPPLIER_CREATED: 'stock_take_multi_supplier_created',
  EMPTY_STATE_CTA_CLICKED: 'stock_take_empty_state_cta_clicked',
})

export const beginStockTakeHistorySearchUsed = (alreadyTracked, query) => {
  const trimmed = String(query || '').trim()
  if (!trimmed) return { tracked: false, fire: false }
  if (alreadyTracked) return { tracked: true, fire: false }
  return { tracked: true, fire: true, queryLength: trimmed.length }
}

export const trackStockTakeAnalytics = (
  venueId,
  { eventName, platform = 'dashboard', stockTakeId, metadata = {} } = {},
) => {
  if (!venueId || !eventName) return
  postGrowthEngineAnalytics(venueId, {
    eventName,
    featureId: 'stock_takes',
    platform,
    metadata: {
      ...(stockTakeId ? { stockTakeId: String(stockTakeId) } : {}),
      ...metadata,
    },
  }).catch(() => {})
}
